export default {"src":"/_next/static/media/Message-blue.277943af.svg","height":20,"width":22};